import { initializeApp, type FirebaseOptions } from "firebase/app";
import { getAuth, GoogleAuthProvider, GithubAuthProvider } from "firebase/auth";

const firebaseConfig: FirebaseOptions = {
  apiKey: "AIzaSyCH2pNJ7vGI1oCDFt1S9qY0wjktGZX7Mvg",
  authDomain: "trustforge-16a42.firebaseapp.com",
  projectId: "trustforge-16a42",
  storageBucket: "trustforge-16a42.firebasestorage.app",
  messagingSenderId: "916981690259",
  appId: "1:916981690259:web:6a1a0b8ed9dc10fb6f4266",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const githubProvider = new GithubAuthProvider();
